import React from 'react';
import { Text, Flex, Image, Box } from 'rebass';
import Slider from 'react-slick';
import reviewsImage from './assets/reviews.png';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const settings = (slidesToShow) => ({
    dots: true,
    infinite: false,
    className: "center",
    centerMode: true,
    speed: 500,
    centerPadding: "60px",
    slidesToShow: 1.5,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
                dots: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: true,
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                // infinite: true,
            }
        }
    ]
});

const Reviews = ({ reviews, slidesToShow }) => <Box py={3} maxWidth={600} m="auto" className="slider-container" sx={{ overflow: "hidden" }} >
    <Box >
        <Slider {...settings(slidesToShow)} >
            {reviews.map(({ title, review, reviewer }) => <Flex flexDirection="column" mr={3}>
                <Flex flexDirection="column" bg="#FFF" sx={{
                    borderRadius: '10px',
                    border: '2px solid #F5EEF8'
                }} p="14px" height={149} justifyContent="center" >
                    <Text
                        color="#0E0E0E"
                        fontSize={14}
                        fontFamily="Poppins"
                        lineHeight="150%"
                        fontWeight={400}
                        letterSpacing="-0.28px"
                    >
                        {review}
                    </Text>
                </Flex>
                <Flex justifyContent="center" alignItems="center" mt={1}>
                    <Flex alignItems="center">
                        <Image width="48px" height="48px" src={reviewer.image} mr={1} sx={{ borderRadius: '50%' }} />
                        <Text
                            color="#0E0E0E"
                            fontSize={14}
                            fontFamily="Poppins"
                            lineHeight="150%"
                            fontWeight={400}
                            letterSpacing="-0.28px"
                        >
                            {reviewer.name}
                        </Text>
                    </Flex>
                    <Image src={reviewsImage} maxWidth={150} mr={3} height={"26px"} ml="auto" />
                </Flex>
            </Flex>
            )}
        </Slider>
    </Box>
</Box>

export default Reviews